import { Welcome } from "./pages/Welcome";
import { Quiz } from "./pages/Quiz";
import { Result } from "./pages/Result";
import { useEffect, useState } from "react";

type Screen = "welcome" | "quiz" | "result";

export default function BalanceTest() {
  const [screen, setScreen] = useState<Screen>("welcome");
  const [balanceScore, setBalanceScore] = useState<number>(0);
  
  function handleNavigate(nextScreen: string, score?: number): void { 
    if (score !== undefined) {
      setBalanceScore(score);
    }
    setScreen(nextScreen as Screen);
  }
   
  return (
    <div className="pt-6 pb-6 background-sand">
      <>
         {screen === "welcome" && <Welcome onNavigate={(nextScreen) => handleNavigate(nextScreen)} />}
         {screen === "quiz" && <Quiz onNavigate={(nextScreen, score) => {
            handleNavigate(nextScreen, score);
         }} />}
         {screen === "result" && <Result onNavigate={() => handleNavigate('welcome')} balanceScore={balanceScore} />} 
      </>
      
    </div>
  );
}

 